import { HStack, VStack } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const ItemRow = HStack.withConfig(({ isLastItem }: { isLastItem: boolean }) => ({
  borderBottomWidth: isLastItem ? 0 : 1,
  borderColor: getDesignToken('border-color-options'),
}));

export const AddExtrasDebugMenuContainer = VStack.withConfig({
  backgroundColor: getDesignToken('icon-button-primary'),
});
